import {
  faHouse,
  faTable,
  faTableColumns,
  faBarChart,
  faChartColumn,
  faChartLine,
  faChartSimple,
  faEnvelope,
  faArrowAltCircleLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { ContactUs } from "../pages/contactus/ContactUs";
import { BalanceSheet } from "../pages/demos/celeri-demo/BalanceSheet";
import { EbitdaCovenantSummary } from "../pages/demos/celeri-demo/EbitdaCovenantSummary";
import { EbitdaFinancialModeling } from "../pages/demos/celeri-demo/EbitdaFinancialModeling";
import { EbitdaRegCapital } from "../pages/demos/celeri-demo/EbitdaRegCapital";
import { FinancialModelingCeleri } from "../pages/demos/celeri-demo/FinancialModelingCeleri";
import { IncomeStatement } from "../pages/demos/celeri-demo/IncomeStatement";
import { SignOut } from "../pages/sign-out/SignOut";
import { SubdomainOrgIdObject } from "./FunctionsAndInterfaces";

const orgId: number = -1;
const subDomain: string = "servdemo";
const nameOfProduct: string = "Serv demo";
const secureRouteGroups: string[] = ["celeri"];

export const celeriObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
};

const sidebarMenu = () => {
  return (
    <>
      <MenuItem>
        <Link to={`/${subDomain}`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faHouse} />
            Home
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/incomestatement`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faTable} />
            Income Statement
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/balancesheet`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faTableColumns} />
            Balance Sheet
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/financialmodel`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faBarChart} />
            Financial Model
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/covenantsummary`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faChartColumn} />
            Covenant Summary
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/debtcovenant`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faChartLine} />
            Debt Covenant
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/regcapitalcov`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faChartSimple} />
            Reg. Capital Cov.
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/contactus`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faEnvelope} />
            Contact Us
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/signout`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
            Log Out
          </div>
        </Link>
      </MenuItem>
    </>
  );
};

export const celeriRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<IncomeStatement />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/incomestatement`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<IncomeStatement />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/balancesheet`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<BalanceSheet />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/financialmodel`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<FinancialModelingCeleri />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/debtcovenant`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<EbitdaFinancialModeling />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/covenantsummary`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<EbitdaCovenantSummary />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/regcapitalcov`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<EbitdaRegCapital />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};
